import { render } from "./shade.vue?vue&type=template&id=451c9032"
import script from "./shade.vue?vue&type=script&lang=js"
export * from "./shade.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260723164601/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__